import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { keHoachThucTapPhamViApi } from "../../../api/xet-thuc-tap/keHoachThucTapPhamViApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eKeHoachThucTapPhamViActionIds, IKeHoachThucTapPhamViActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eKeHoachThucTapPhamViSinhVienActionIds, IKeHoachThucTapPhamViSinhVienActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienActions";
import { keHoachThucTapPhamViSinhVienApi } from "../../../api/xet-thuc-tap/keHoachThucTapPhamViSinhVienApi";
import { IKeHoachThucTapPhamViSinhVien } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapPhamViSinhVien";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachThucTapPhamViSinhVienSelectRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienSelectRequest";
import { IKeHoachThucTapPhamViSinhVienInsertRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienInsertRequest";

export function* keHoachThucTapPhamViSinhVienSaga(): any {
    yield takeLatest(eKeHoachThucTapPhamViSinhVienActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotXetWorker);
    yield takeEvery(eKeHoachThucTapPhamViSinhVienActionIds.INSERTS_START, addsWorker);
    yield takeEvery(eKeHoachThucTapPhamViSinhVienActionIds.DELETES_START, deletesWorker);
}

    
function* loadByDotXetWorker(action: IKeHoachThucTapPhamViSinhVienActionTypes) : any {
    const request = action.payload as IKeHoachThucTapPhamViSinhVienSelectRequest;
    const response : IBaseResponse = yield keHoachThucTapPhamViSinhVienApi.SelectByDotThucTap(request);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.LOAD_BY_DOT_THUC_TAP_ERROR(response.message ?? "Lỗi khi tải phạm vi kế hoạch thực tập"));
    }
}

function* addsWorker(action: IKeHoachThucTapPhamViSinhVienActionTypes) : any {
    const data = action.payload as IKeHoachThucTapPhamViSinhVienInsertRequest;
    const response: IBaseResponse = yield keHoachThucTapPhamViSinhVienApi.Inserts(data);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.INSERTS_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.INSERTS_ERROR(response.message ?? "Lỗi khi thêm phạm vi kế hoạch thực tập"));
    }
}

function* deletesWorker(action: IKeHoachThucTapPhamViSinhVienActionTypes) : any {
    const ids = action.payload as IIdsRequest;
    const response: IBaseResponse = yield keHoachThucTapPhamViSinhVienApi.Deletes(ids);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.DELETES_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamViSinhVien.DELETES_ERROR(response.message ?? "Lỗi khi xóa phạm vi kế hoạch thực tập"));
    }
}